module.exports = __webpack_public_path__ + "static/media/arrow-down.126c6b2f.svg";